module.exports = __webpack_public_path__ + "static/img/j1.ba654141.jpg";